const defaultProtocol = 'https://';

export const isValidUrl = (urlString: string, withProtocol = true) => {
    const urlWithProtocol = withProtocol ? urlString : addProtocol(urlString);

    let url;
    try {
        url = new URL(urlWithProtocol);
    } catch {
        return false;
    }

    return url.protocol === 'http:' || url.protocol === 'https:';
};

export const addProtocol = (urlString: string) => `${defaultProtocol}${urlString}`;

export function removeProtocol(urlString: string): string {
    try {
        const url = new URL(urlString);
        return url.href.replace(url.protocol + '//', '');
    } catch {
        return urlString;
    }
}
